module.exports = __webpack_public_path__ + "static/media/07.10275293.png";